import { render, staticRenderFns } from "./WorkflowPrepProcessAuditTrailHistory.vue?vue&type=template&id=0fe0df5e"
import script from "./WorkflowPrepProcessAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepProcessAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports